import { render, staticRenderFns } from "./AppSnackbars.vue?vue&type=template&id=39b37cf4&"
import script from "./AppSnackbars.vue?vue&type=script&lang=js&"
export * from "./AppSnackbars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports